import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { Modal, Button } from "@mantine/core";
import { AiOutlineCloseCircle } from "react-icons/ai";

const StakeRulesDialog: FunctionComponent<{
  opened: boolean;
  onClose: any;
  onAgree?: any;
}> = ({ opened, onClose, onAgree }) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      centered
      size={400}
      radius={16}
      zIndex={999}
    >
      <div className="pt-5 pb-5 relative px-5 flex flex-col items-center">
        <AiOutlineCloseCircle
          size={26}
          className="fill-primary action absolute right-0 top-0"
          onClick={onClose}
        ></AiOutlineCloseCircle>
        <div className="font-semibold text-lg">Staking Rules</div>
        <div className="whitespace-pre-line mt-10 text-xs">{`1. You will only be allowed to unstake after 48 hours. When you unstake, a 5% fee in KAT tokens will be automatically burned.

2. Staking rewards can be claimed daily at 3:00 PM Pacific Time (T+2). Claiming staking rewards will result in the burning of 5% of KAT.`}</div>
        <div className="flex items-center justify-center gap-8 mt-10">
          <Button
            size="md"
            radius="xl"
            className="sm:w-[149px] bg-[#E0E1E1] text-dark2 hover:bg-[#E0E1E1]"
            onClick={onClose}
          >
            cancel
          </Button>
          <Button
            size="md"
            radius="xl"
            className="sm:w-[149px]"
            onClick={() => {
              onClose();
              onAgree();
            }}
          >
            I agree
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default StakeRulesDialog;
